<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <span>{{ message }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">
          確定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: ['title', 'message'],
  data() {
    return {
      dialogVisible: false,
    }
  },
  methods: {
    openModal(message) {
      this.message = message
      this.dialogVisible = true
    },
    handleClose(done) {
      this.$confirm('確定關閉？')
        .then((_) => {
          done()
        })
        .catch((_) => {})
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/element_ui/BasicModal.vue